import { Page } from 'react-pdf';

import { HighlightCanvas } from '../highlight-canvas';
import { DocViewerLoader } from './doc-viewer-loader';
import { BoundingBoxWithId } from '@/types';

interface PDFPageProps {
  pageNumber: number;
  top: number;
  dimensions: { width: number; height: number };
  highlights: BoundingBoxWithId[];
  onHighlightClick?: (id: string) => void;
  highlightedFactId?: string | null;
  highlightedChunkId?: string | null;
  onPageLoadSuccess?: (pageNumber: number, dimensions: { width: number; height: number }) => void;
}

export const PDFPage = ({
  pageNumber,
  top,
  dimensions,
  highlights,
  highlightedFactId,
  onHighlightClick,
  highlightedChunkId,
  onPageLoadSuccess,
}: PDFPageProps) => {
  return (
    <div
      className="absolute shadow-lg"
      style={{
        top,
        left: '50%',
        transform: 'translateX(-50%)',
        width: dimensions.width,
      }}
    >
      <HighlightCanvas
        highlights={highlights}
        pageNumber={pageNumber}
        width={dimensions.width}
        height={dimensions.height}
        highlightedFactId={highlightedFactId}
        onHighlightClick={onHighlightClick}
        highlightedChunkId={highlightedChunkId}
      />
      <Page
        pageNumber={pageNumber}
        width={dimensions.width}
        height={dimensions.height}
        renderTextLayer={false}
        renderAnnotationLayer={false}
        loading={<DocViewerLoader />}
        onLoadSuccess={(page) => {
          const viewport = page.getViewport({ scale: 1 });
          onPageLoadSuccess?.(pageNumber, { width: viewport.width, height: viewport.height });
        }}
      />
    </div>
  );
};
